import { Injectable, inject } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ConversationInspector } from '../components/conversation-info/conversation-inspector';
import { IAgentCard } from '../models/agent.models';
import { ChatUserSettings } from '@dataclouder/ngx-core';

@Injectable({
  providedIn: 'root',
})
export class ConversationInfoService {
  private dialogService = inject(DialogService);

  openConversationInfo(data: { agentCard: IAgentCard; chatUserSettings: ChatUserSettings }) {
    this.dialogService.open(ConversationInspector, {
      header: 'Conversation Inspection',
      width: '90vw',
      modal: true,
      draggable: false,
      closable: true,
      data,
    });
  }
}
